import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';
import { Login } from '../Models/login.model';
import { JWTTokenResponse, Permission, PermissionType } from '../Models/JWTTokenResponse.model';
import { HttpClient } from '@angular/common/http';
import { SaveInBrowser } from '../core/SaveInBrowser';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  private readonly tokenKey = 'jwtToken';
  private userCodesSubject: BehaviorSubject<Permission[]> = new BehaviorSubject<Permission[]>([]);
  public userCodes$ = this.userCodesSubject.asObservable();
  //Login need to change to Auth
  URL = `${environment.apiUrl}Login/Login/`;
  constructor(
    private _http: HttpClient,
    private _storageService: SaveInBrowser
  ) {
    // Initialize permissions from localStorage on app startup
    this.initializePermissions();
  }

  private initializePermissions(): void {
    const permissions = this.getUserCodes();
    this.userCodesSubject.next(permissions);
  }

  login(user: Login): Observable<JWTTokenResponse> {
    // return this._http.post<JWTTokenResponse>(this.URL, user);
    return this._http.post<JWTTokenResponse>(this.URL, user)
      .pipe(
        tap(response => {

          // Only save token and permissions if login was successful
          if (response.success) {
            // Save the JWT token to local storage
            this._storageService.setItem(this.tokenKey, response.token);
            this._storageService.setItem('permissions', response.permissions);
            // Emit the new permissions to notify subscribers
            this.userCodesSubject.next(response.permissions || []);
          }
        })
      );
  }

  logout(): void {
    this._storageService.removeItem(this.tokenKey);
    this._storageService.removeItem('permissions');
    this._storageService.removeItem('user');
    // Clear permissions from the subject
    this.userCodesSubject.next([]);
  }

  getUserCodes() {
    const permissions = this._storageService.getItemBy('permissions');
    if (permissions) {
      return JSON.parse(permissions);
    } else return [];
  }

  // Convenience getters/checkers
  getPermissions(): Permission[] {
    return this.getUserCodes() as Permission[];
  }

  hasPermission(securityCode: string, allowed: PermissionType[] = [PermissionType.View, PermissionType.Edit]): boolean {
    const permissions = this.getPermissions();
    const match = permissions.find(p => p.securityCode === securityCode);
    if (!match) return false;
    return allowed.includes(match.permission as PermissionType);
  }

  hasPermission$(securityCode: string, allowed: PermissionType[] = [PermissionType.View, PermissionType.Edit]): Observable<boolean> {
    return this.userCodes$.pipe(
      map(perms => {
        const match = (perms || []).find(p => p.securityCode === securityCode);
        if (!match) return false;
        return allowed.includes(match.permission as PermissionType);
      })
    );
  }
  // isLoggedInUser(): boolean {
  //   return !!this._storageService.getItemBy('user');
  // }

  getJwtToken(): string | null {
    // Retrieve the JWT token from local storage or wherever you stored it
    return this._storageService.getItemBy(this.tokenKey);
  }

  isLoggedInUser(): boolean {
    return !!this.getJwtToken();
  }
}
